/**
 * Pre-compiled de messages for ModalPage
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  backButton: (args: Record<string, string | number>) =>
    `Zurück zu ${args.previousPathLabel}`,
};
